import {PreferredPaymentTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function driverPreferredPaymentTypeNameFilter(type: PreferredPaymentTypeEnum) {
  switch (type) {
    case PreferredPaymentTypeEnum.Daily: return i18n.t(LF.Daily) as string;
    case PreferredPaymentTypeEnum.Weekly: return i18n.t(LF.Weekly) as string;
    case PreferredPaymentTypeEnum.OnDemand: return i18n.t(LF.OnDemand) as string;
  }
}
